module.exports = __webpack_public_path__ + "img/humidity.445cea8a.svg";